import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector, useAppDispatch } from "../../hooks/hooks";
import { searchAppData, clearSearch } from "../../features/store/appDataSlice";
import { CardContainer } from "../Homepage/CardContainer";
import { SectionContainer } from "../Homepage/SectionContainer";
import { Header } from "../Homepage/Header";

const SearchResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { searchResults, searchQuery, isSearching } = useAppSelector(
    (state) => state.appData
  );

  // Extract search query from URL
  const query = new URLSearchParams(location.search).get("q") || "";

  useEffect(() => {
    if (query) {
      dispatch(searchAppData(query));
    }

    return () => {
      // Clear search when leaving the page
      dispatch(clearSearch());
    };
  }, [query, dispatch]);

  if (isSearching) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const categories = [
    {
      key: "most_popular",
      title: "Most Popular Today",
      icon: "/png/PrepaidServices.png",
    },
    {
      key: "topup_plans",
      title: "Direct Game Topup",
      icon: "/png/PrepaidServices.png",
    },
    {
      key: "game_cards",
      title: "Game Cards",
      icon: "/png/PrepaidServices.png",
    },
    {
      key: "gift_cards",
      title: "Gift Cards",
      icon: "/png/PrepaidServices.png",
    },
    { key: "data", title: "Data Services", icon: "/png/PrepaidServices.png" },
    {
      key: "airtime",
      title: "Airtime Services",
      icon: "/png/PrepaidServices.png",
    },
    { key: "cable", title: "Cable TV", icon: "/png/PrepaidServices.png" },
    {
      key: "electric",
      title: "Electric Payment",
      icon: "/png/PrepaidServices.png",
    },
  ];

  const searchResultsAny = searchResults as any;
  const hasResults = categories.some(
    (category) => searchResultsAny[category.key]?.providers?.length > 0
  );

  if (!hasResults) {
    return (
      <div className="min-h-screen p-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Search Results for "{query}"
          </h1>
          <div className="text-center py-12">
            <p className="text-gray-500 dark:text-gray-400 text-lg">
              No results found for "{query}"
            </p>
            <button
              onClick={() => navigate("/")}
              className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              Back to Home
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
          Search Results for "{query}"
        </h1>

        {categories.map(({ key, title, icon }) => {
          const category = (
            searchResults as Record<string, { providers?: any[] } | undefined>
          )[key];
          const providers = category?.providers;

          if (!providers || providers.length === 0) {
            return null;
          }

          return (
            <SectionContainer key={key} id={`search-${key}`}>
              <Header icon={icon} title={title} viewAllUrl={key} />
              <CardContainer cardData={providers} url={key} />
            </SectionContainer>
          );
        })}
      </div>
    </div>
  );
};

export default SearchResults;
